var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadDetailForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 17.5C6.07146 17.5 4.10728 17.5 2.8869 16.2796C1.6665 15.0592 1.6665 13.095 1.6665 9.16667V6.62023C1.6665 5.1065 1.6665 4.34963 1.98344 3.78172C2.20935 3.37689 2.5434 3.04285 2.94822 2.81693C3.51614 2.5 4.273 2.5 5.78673 2.5C6.75652 2.5 7.24142 2.5 7.66589 2.65917C8.635 3.0226 9.03467 3.90298 9.472 4.77761L9.99984 5.83333M6.6665 5.83333H13.9582C15.7138 5.83333 16.5915 5.83333 17.2221 6.25466C17.4951 6.43706 17.7294 6.67143 17.9118 6.94441C18.3332 7.57497 18.3332 8.45275 18.3332 10.2083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5H12.5M18.3333 15H12.5M14.5833 17.5H12.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadDetailForm);
export default __webpack_public_path__ + "static/media/lead-detail-form.2d7da3968baa7683dfd5b84cbec947a9.svg";
export { ForwardRef as ReactComponent };